export const formatPhoneNumber = (format, number) => {
  let num = number;
  return format
    .split('')
    ?.reduce((arr, char) => {
      if (char === '.') {
        const d = num[0];
        num = num.slice(1);
        return [...arr, d];
      }
      return [...arr, char];
    }, [])
    ?.join('');
};
